import Req from '../../$axios';
const serviceModule = {
  // 获取全部项目
  listOfAllProjectsIndex(params) {
    return Req({
      url: 'project/listOfAllProjectsIndex',
      method: 'get',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 管理员加入项目
  addProjectMember(params) {
    return Req({
      url: 'project/addProjectMember',
      method: 'post',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
}
export default {
  ...serviceModule
};
